<template>
  <Article>
    <Heading as="h1">
      <!--  -->
      Corporate
    </Heading>
    <p>
      The principal lawyers of Hobson Bernardino + Davis LLP provide general
      in-house counsel services to a wide range of clients in various industries
      and sectors, advising them on legal issues encountered in everyday
      business operations. In other cases, clients seek our help as local or
      special counsel on complex transactional or operational matters, such as:
    </p>
    <ul>
      <li>Commercial Finance</li>
      <li>Corporate Governance</li>
      <li>Financial Restructuring</li>
      <li>International Finance</li>
      <li>Mergers and Acquisitions</li>
      <li>Private and Public Debt and Equity Financing</li>
      <li>
        Special Needs of Banks, Emerging Businesses and Entertainment Companies
      </li>
      <li>Bankruptcy workouts and dispositions</li>
      <li>Intellectual property protection</li>
      <li>Commercial licensing and distribution agreements</li>
      <li>Executive compensation and employee benefits</li>
      <li>
        Tax-exempt organization qualification, operations and fundraising
        activities
      </li>
      <li>Commercial licensing and distribution agreements</li>
    </ul>
    <p>
      All of the attorneys with Hobson Bernardino + Davis LLP are big law firm
      veterans as well as previously in-house lawyers for national companies. As
      such, we understand in-house dynamics and the added value of accessible
      legal counsel. Our corporate services are tailored to each client’s unique
      operating environment and growth sensitivities. Our clients include
      multinational corporations, middle-market businesses, start-up joint
      venture entities, entrepreneurs and nonprofit organizations in different
      sectors including aviation and aerospace, national and community banks,
      media and telecommunications, sports and entertainment, education, energy
      and utilities, health care and biotechnology, manufacturing to commercial
      real estate.
    </p>
  </Article>
</template>

<script setup>
defineOptions({ name: "ViewDisclaimer" });
import Article from "../components/Article.vue";
import Heading from "../components/Heading.vue";
</script>
